var _circle, _path, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiVerdeSlider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2748,
    cy: 10.9672,
    r: 10.2201,
    fill: "#15CA2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22971 13.87C6.10723 13.6515 5.83078 13.5736 5.61223 13.6961C5.39367 13.8185 5.31579 14.095 5.43826 14.3136L6.22971 13.87ZM15.352 14.3291C15.483 14.1156 15.4162 13.8363 15.2027 13.7052C14.9892 13.5741 14.7098 13.641 14.5788 13.8545L15.352 14.3291ZM5.43826 14.3136C6.6405 16.4589 8.54144 17.4313 10.4556 17.3597C12.3542 17.2887 14.2076 16.1933 15.352 14.3291L14.5788 13.8545C13.5787 15.4836 11.9906 16.3944 10.4217 16.4531C8.8684 16.5112 7.27586 15.7369 6.22971 13.87L5.43826 14.3136Z",
    fill: "#FBFFFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.45909,
    cy: 8.77745,
    r: 1.83605,
    fill: "#FBFFFA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4845,
    cy: 8.77745,
    r: 1.83605,
    fill: "#FBFFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiVerdeSlider);
export default __webpack_public_path__ + "static/media/emojiVerdeSlider.b8341c6c68bada83835a17eec8eac2d7.svg";
export { ForwardRef as ReactComponent };